import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { CheckCircleOutlined as e } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/check-circle-outlined.es.es.js";
import { ExclamationCircleOutlined as n$1 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/exclamation-circle-outlined.es.es.js";
import { TriangleExclamationOutlined as t } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/triangle-exclamation-outlined.es.es.js";
import { BookTextSolid as n } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/book-text-solid.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
const alertDefaultProps = {
  iconMapping: {
    success: /* @__PURE__ */ jsx(e, { fontSize: "inherit" }),
    info: /* @__PURE__ */ jsx(n, { fontSize: "inherit" }),
    error: /* @__PURE__ */ jsx(n$1, { fontSize: "inherit" }),
    warning: /* @__PURE__ */ jsx(t, { fontSize: "inherit" })
  }
};
export {
  alertDefaultProps
};
//# sourceMappingURL=default-props.es.js.map
